module.exports = __webpack_public_path__ + "static/media/loading.4d2f216e.gif";